import { GroundFragment } from '@amf/shared/types/graphql';
import GroundListItem from '@amf/shared/components/ground/GroundListItem';

interface Props {
  grounds: GroundFragment[];
  prefixes: { ground: string };
}

function GroundList({ grounds, prefixes }: Props) {
  return (
    <div className='GroundList'>
      {grounds.map(ground => (
        <GroundListItem key={ground.id} ground={ground} prefixes={prefixes} />
      ))}
    </div>
  );
}

export default GroundList;
